/**
 * section-vt-shop-section.js
 * ──────────────────────────
 * Initialises Splide.js for the VT Shop Section mobile slider and wires
 * up the custom segmented pagination indicator.
 *
 * Splide is loaded via CDN (see section liquid) with `defer`, so this
 * script also uses `defer` — the browser guarantees execution order for
 * sibling defer scripts, so Splide will always be available here.
 */
(function () {
  'use strict';

  function initSection(splideEl) {
    if (typeof Splide === 'undefined') return;

    var sectionEl   = splideEl.closest('.vtss');
    var pagination  = sectionEl && sectionEl.querySelector('[data-vtss-pagination]');
    var segments    = pagination
      ? Array.from(pagination.querySelectorAll('.vtss__pag-segment'))
      : [];

    /* ── Splide instance ── */

    var splide = new Splide(splideEl, {
      type       : 'slide',
      gap        : 45,        // same gap as desktop grid
      pagination : false,     // using custom segmented pagination below
      arrows     : false,
      mediaQuery : 'min',     // breakpoints are min-width
      perMove: 1,
      perPage: 1,
      padding: {
        right: '40%',
        left: 16
      },
      breakpoints: {
        650: {
          perPage: 2,
          padding: {
            right: '30%',
            left: 16
          },
        },
        921: {
          destroy: true       // revert to plain HTML on desktop
        }
      }
    });

    /* ── Custom pagination sync ── */

    function setActive(index) {
      segments.forEach(function (seg, i) {
        seg.classList.toggle('is-active', i === index);
      });
    }

    if (segments.length) {
      // Update active segment when Splide moves to a new slide
      splide.on('move', function (newIndex) {
        setActive(newIndex);
      });

      // Click a segment to jump to that slide
      segments.forEach(function (seg, i) {
        seg.addEventListener('click', function () {
          splide.go(i);
        });
      });
    }

    splide.mount();
  }

  /* ── Init all instances on the page ── */

  function init() {
    document.querySelectorAll('.vtss__splide').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
